// 判断客户端是否为pc
function isPC(userAgentInfo) {
  // const userAgentInfo = navigator.userAgent
  const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
  let flag = true
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  return flag
}

// 全屏显示
function openFullScreen(element) {
  if (element.requestFullscreen) {
      element.requestFullscreen()
  } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen()
  } else if (element.webkitRequestFullScreen) {
      element.webkitRequestFullScreen()
  } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen()
  }
}

function exitFullScreen(document) {
  if(document.exitFullscreen) {
      document.exitFullscreen()
  } else if(document.mozCancelFullScreen) {
      document.mozCancelFullScreen()
  } else if(document.webkitExitFullscreen) {
      document.webkitExitFullscreen()
  } else if(document.msExitFullscreen) {
      document.msExitFullscreen()
  }
}

export { isPC, openFullScreen, exitFullScreen }


//////////////////
// WEBPACK FOOTER
// ./static/util/pqtutil.js
// module id = null
// module chunks = 